module.exports = __webpack_public_path__ + "img/shackshack-text.6e27a5c8.svg";